import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import reportService from '../api/reports'

Vue.use(Vuex)

const initialState = {
  reports: [],
  reportInfo: {}
}

const getters = {
  reports(state) {
    return state.reports
  },
  reportInfo(state) {
    return state.reportInfo
  },
}

export const actions = {
  async getReports(contex, payload) {
    try {
      const response = await reportService.getReports(payload);
      contex.commit('reports', response.data.reports, { root: true })
      return Promise.resolve();
    } catch (error) {
      var errorMessage = contex.rootState.langObj.response.error[error.response.data] || contex.rootState.langObj.response.error.somethingWentWrong
      contex.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
    // return new Promise((resolve, reject) => {
    //   reportService.getReports(payload).then((response) => {
    //     contex.commit('reports', response.data.reports, { root: true })
    //     resolve()
    //   }).catch(error => {
    //     var errorMessage = contex.rootState.langObj.response.error[error.response.data] || contex.rootState.langObj.response.error.somethingWentWrong
    //       contex.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true })
    //     reject(error)
    //   })
    // })
  },
  async getReportInfo(contex, payload) {
    try {
      const response = await reportService.getReportInfo(payload);
      contex.commit('reportInfo', response.data.reports, { root: true })
      return Promise.resolve();
    } catch (error) {
      var errorMessage = contex.rootState.langObj.response.error[error.response.data] || contex.rootState.langObj.response.error.somethingWentWrong
      contex.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async reportEntity(contex, payload) {
    try {
      const response = await reportService.reportEntity(payload);
      contex.commit('toast', { message: contex.rootState.langObj.reports.SuccessfullyReported, color: 'black' }, { root: true })
      return Promise.resolve();
    } catch (error) {
      var errorMessage = contex.rootState.langObj.response.error[error.response.data] || contex.rootState.langObj.response.error.somethingWentWrong
      contex.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async resolveReport(contex, payload) {
    try {
      const response = await reportService.resolveReport(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.changed, color: 'black' }, { root: true })
      return Promise.resolve();
    } catch (error) {
      var errorMessage = contex.rootState.langObj.response.error[error.response.data] || contex.rootState.langObj.response.error.somethingWentWrong
      contex.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions
}
